<template>
  <v-autocomplete
    id="consultant-select"
    v-model="filter.consultorId"
    item-text="nome"
    item-name="usuarioId"
    item-value="usuarioId"
    :items="users"
    :label="
      !this.isAT || this.$store.state.uf === 'MA'
        ? this.consultorValue || 'Responsável'
        : this.isAT
        ? 'ATS'
        : 'Consultor'
    "
    :placeholder="consultorLabel"
    :multiple="isMultiple"
    clearable
  >
    <template slot="no-data"> Nenhum usuário retornado </template>
  </v-autocomplete>
</template>

<script>
import { userAPI } from "./UserAPI";
import { mapGetters } from "vuex";

export default {
  name: "AppConsultoresCombobox",
  props: ["filter", "consultorValue", "isMultiple"],
  mounted() {
    this.loadConsultant();
  },
  computed: {
    ...mapGetters(["isAT"]),
  },
  methods: {
    loadConsultant() {
      userAPI
        .listConsultores()
        .then((resp) => {
          this.users = resp.data.filter((item) => item.habilitado);
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter usuários");
        });
    },
  },
  data() {
    return {
      users: [],
      consultorLabel: "Consultor",
    };
  },
};
</script>
